import React from "react";
import { Link } from "react-router-dom";

const DonorProfile = () => {
  return (
    <div className="donor-profile">
      <h1>Perfil del Donante</h1>
      <Link to="/received-requests" className="btn btn-primary">
        Ver Solicitudes Recibidas
      </Link>
    </div>
  );
};

export default DonorProfile;